<template>
  <el-dialog
    :before-close="noDialog"
    :fullscreen="dialogFullscreen"
    :visible.sync="dialog"
    title="创建车辆"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form ref="ruleForm" :model="form" :rules="rules" label-width="auto">
      <el-row>
        <el-col :span="12" :xs="24">
          <el-form-item label="绑定车库" prop="carportId">
            <el-select
              v-model="form.carportId"
              placeholder="请选择车库"
              @change="handleCarportChange"
              filterable
              ref="select"
              @focus="closeReadOnly"
              @hook:mounted="closeReadOnly"
              @visible-change="closeReadOnly"
            >
              <el-option
                v-for="item in carportList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12" :xs="24">
          <el-form-item label="车辆类型" prop="carTypeId">
            <el-select
              v-model="form.carTypeId"
              placeholder="请选择车辆类型"
              filterable
              ref="select"
              @focus="closeReadOnly"
              @hook:mounted="closeReadOnly"
              @visible-change="closeReadOnly"
            >
              <el-option
                v-for="item in carTypeList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12" :xs="24">
          <el-form-item label="车牌号码" prop="plateNumber">
            <el-input
              v-model="form.plateNumber"
              maxlength="7"
              placeholder="请输入车牌号码"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12" :xs="24">
          <el-form-item label="绑定类型">
            <el-radio-group
              v-model="form.bindType"
              @input="handleRadioGroupInput"
            >
              <el-radio class="xs-mp-10" label="2" border>电卡</el-radio>
              <el-radio class="xs-mp-10" label="1" border
                >用户(虚拟卡)</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12" :xs="24">
          <el-form-item
            v-if="form.bindType == '1'"
            label="用户编号"
            prop="memberId"
          >
            <el-select
              v-model="form.memberId"
              placeholder="请通过编号选择用户"
              filterable
              ref="select"
              @focus="closeReadOnly"
              @hook:mounted="closeReadOnly"
              @visible-change="closeReadOnly"
              remote
              reserve-keyword
              :remote-method="remoteGetUserMethod"
              :loading="loading"
            >
              <el-option
                v-for="item in userList"
                :key="item.id"
                :label="
                  item.nickName +
                  ` (${item.platform}${item.phone === '0' ? '' : item.phone})`
                "
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            v-if="form.bindType == '2'"
            label="卡号选择"
            prop="cardId"
          >
            <el-select
              v-model="form.cardId"
              placeholder="请输入并选择卡号"
              filterable
              ref="select"
              @focus="closeReadOnly"
              @hook:mounted="closeReadOnly"
              @visible-change="closeReadOnly"
              remote
              reserve-keyword
              :remote-method="remoteGetCardMethod"
              :loading="loading2"
            >
              <el-option
                v-for="item in cardList"
                :key="item.id"
                :label="item.cardId + ` (${item.name})`"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12" :xs="24">
          <el-form-item label="正面照片" prop="fullFaceImg">
            <el-upload
              action="#"
              :show-file-list="false"
              :http-request="handleCarImgSuccess"
              :data="{ key: 'fullFaceImg' }"
            >
              <img
                v-if="form.fullFaceImg"
                :src="form.fullFaceImg"
                class="car_upload_img"
              />
              <div v-else class="car_uploader_icon">
                <i class="el-icon-plus"></i>
              </div>
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col :span="12" :xs="24">
          <el-form-item label="侧面照片" prop="leftImg">
            <el-upload
              action="#"
              :show-file-list="false"
              :http-request="handleCarImgSuccess"
              :data="{ key: 'leftImg' }"
            >
              <img
                v-if="form.leftImg"
                :src="form.leftImg"
                class="car_upload_img"
              />
              <div v-else class="car_uploader_icon">
                <i class="el-icon-plus"></i>
              </div>
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :xs="24">
          <el-form-item label="备注信息">
            <el-input
              v-model="form.remark"
              type="textarea"
              placeholder="无备注"
              show-word-limit
              maxlength="60"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer">
      <el-button @click="noDialog">取 消</el-button>
      <el-button type="primary" @click="addCar">提交</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { Message } from "element-ui";
import dialogMixin from "@/mixin/dialogMixin";
import resDisposeMixin from "@/mixin/resDisposeMixin";
import CarPort from "@/api/device/CarPort";
import agentGetAllUserListById from "@/api/user/agentGetAllUserListById";
import CarTypeController from "@/api/device/CarTypeController";
import agentGetNoCarCardByCardId from "@/api/user/card-manage/agentGetNoCarCardByCardId";
import { debounce } from "@/utils/utils";
import UserCar from "@/api/device/UserCar";

export default {
  name: "createCarDialog",
  mixins: [dialogMixin, resDisposeMixin],
  data() {
    return {
      rules: {
        carportId: [
          {
            required: true,
            message: "请选择车库",
            trigger: ["blur", "change"],
          },
        ],
        carTypeId: [
          {
            required: true,
            message: "请选择车辆类型",
            trigger: ["blur", "change"],
          },
        ],
        memberId: [
          {
            required: true,
            message: "请选择用户",
            trigger: ["blur", "change"],
          },
        ],
        cardId: [
          {
            required: true,
            message: "请选择电卡",
            trigger: ["blur", "change"],
          },
        ],
        fullFaceImg: [
          {
            required: true,
            message: "请上传车辆正面照片",
            trigger: ["blur", "change"],
          },
        ],
        leftImg: [
          {
            required: true,
            message: "请上传车辆侧面照片",
            trigger: ["blur", "change"],
          },
        ],
      },
      form: {
        carportId: undefined,
        carTypeId: undefined,
        plateNumber: "",
        cardId: undefined,
        leftImg: "",
        fullFaceImg: "",
        remark: "",
        bindType: "2",
        memberId: undefined,
        memberType: "",
      },
      carportList: [],
      carTypeList: [],
      userList: [],
      cardList: [],
      loading: false,
      loading2: false,
    };
  },
  created() {
    CarPort.agentGetAllCarport().then((res) => {
      this.carportList = res.data;
    });
  },
  methods: {
    closeReadOnly(value) {
      this.$nextTick(() => {
        if (!value) {
          const { select } = this.$refs;
          const input = select.$el.querySelector(".el-input__inner"); 
          input.removeAttribute("readonly"); 
          // this.$refs.select.blur();  根据tip自行判断是否添加
        }
      });
    },
    // 车辆照片上传成功时触发
    handleCarImgSuccess(event) {
      const that = this;
      const file = event.file;
      const acceptList = ["image/jpeg", "image/jpg", "image/png"];
      if (acceptList.indexOf(file.type) == -1) {
        return Message.error("只允许上传jpg/png图片");
      }
      if (file.size > 10000 * 1024) {
        return Message.error("图片大小必须小于10MB");
      }
      const reader = new FileReader();
      reader.onloadend = () => {
        let canvas = document.createElement("canvas");
        let context = canvas.getContext("2d");

        let img = new Image();
        img.src = reader.result;
        img.onload = function () {
          canvas.width = 500;
          canvas.height = 500;
          if (!context) {
            return;
          }
          context.drawImage(img, 0, 0, 500, 500);
          that.form[event.data.key] = canvas.toDataURL(file.type, 1);
          img = null;
        };
      };
      // file -> base64
      reader.readAsDataURL(file);
    },
    // 选择车库时触发
    handleCarportChange(value) {
      this.form.carTypeId = undefined;
      // 获取车库下的车辆类型
      CarTypeController.agentGetCarTypeByCarportId(value).then((res) => {
        this.carTypeList = res.data;
      });
    },
    addCar() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          if (!this.form.leftImg || !this.form.fullFaceImg) {
            return Message.error("请先上传车辆照片~");
          }

          let dto = { ...this.form };
          // 虚拟卡
          if (dto.bindType === "1") {
            const userParam = dto.memberId.split(",");
            dto.memberType = userParam[0];
            dto.memberId = +userParam[1];
            dto.cardId = -1;
          } else {
            // 电卡
            dto.memberType = "0";
            dto.memberId = 0;
          }
          delete dto.bindType;

          UserCar.agentCreateCar(dto)
            .then((res) => {
              if (res.code === 1) {
                this.$emit("finish");
              } else {
                Message({
                  message: res.msg,
                  type: "error",
                  duration: 3000,
                });
              }
            })
            .finally(() => {
              this.loadDialog.close();
            });
        }
      });
    },
    handleRadioGroupInput(value) {
      this.$nextTick(() =>
        this.$refs["ruleForm"].validateField(value == 1 ? "memberId" : "cardId")
      );
    },
    // 远程获取用户
    remoteGetUserMethod: debounce(function (query) {
      if (query !== "") {
        this.loading = true;
        agentGetAllUserListById(query).then((res) => {
          this.loading = false;
          this.userList = res.data.map((d) => ({
            ...d,
            id: `${d.memberType},${d.id}`,
            platform: d.memberType == "7" ? "支付宝" : "微信",
          }));
        });
      } else {
        this.userList = [];
      }
    }, 350),
    // 远程获取电卡
    remoteGetCardMethod: debounce(function (query) {
      if (query !== "") {
        this.loading2 = true;
        agentGetNoCarCardByCardId(query).then((res) => {
          this.loading2 = false;
          this.cardList = res.data;
        });
      } else {
        this.cardList = [];
      }
    }, 500),
  },
};
</script>

<style lang="scss" scoped>
@import "src/styles/my";
@include mobile {
  /deep/ .el-radio.is-bordered {
    & + .el-radio.is-bordered {
      margin-left: 0 !important;
    }
  }
}

.car_upload_img {
  width: 140px;
  height: 140px;
  border-radius: 6px;
}

.car_uploader_icon {
  width: 140px;
  height: 140px;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #ccc;

  i {
    font-size: 30px;
  }

  &:hover {
    border-color: #66b1ff;
  }
}
</style>
